import './mw-card.css'
import '../rate-document/rate-document.css'
import '../content-stream-tags/content-stream-tags.css'
import imageAvailable from '../image-available/image-available';
import rateDocument from '../rate-document/rate-document';
import contentStreamTags from '../content-stream-tags/content-stream-tags';
import blogDocumentCard from './blog-document-card';
import commentsDocumentCard from './comments-document-card';
import defaultDocumentCard from './default-document-card';
import facebookDocumentCard from './facebook-document-card';
import forumsDocumentCard from './forums-document-card';
import instagramDocumentCard from './instagram-document-card';
import newsDocumentCard from './news-document-card';
import productDocumentCard from './product-document-card';
import twitterDocumentCard from './twitter-document-card';
import youtubeDocumentCard from './youtube-document-card';
import tveyesDocumentCard from './tveyes-document-card';
import trustUrl from '../../filters/TrustUrlFilter';


export default
function (ngModule) {

    imageAvailable(ngModule);
    rateDocument(ngModule);
    contentStreamTags(ngModule);
    blogDocumentCard(ngModule);
    commentsDocumentCard(ngModule);
    defaultDocumentCard(ngModule);
    facebookDocumentCard(ngModule);
    forumsDocumentCard(ngModule);
    instagramDocumentCard(ngModule);
    newsDocumentCard(ngModule);
    productDocumentCard(ngModule);
    twitterDocumentCard(ngModule);
    youtubeDocumentCard(ngModule);
    tveyesDocumentCard(ngModule);
    trustUrl(ngModule);

    ngModule.directive('documentCard', [function(){
        return {
            restrict: 'E',
            template: require('./document-card.html'),
            controller: 'DocumentCardController',
            scope: {
                document: '=',
                displaySettings: '=',
                parentDocumentClick: '&documentClick',
                overlaySentiment: '&',
                showDuplicates: '&',
                docsWithVisibleDuplicates: '=',
                isInfluencerDatabaseEntitled: '=',
                isSocialEchoEntitled: '=',
                isSocialEchoTop25Entitled: '=',
                isEngagementEnabled: '=',
                socialEchoSortingSelected: '=',
                icmBaseUrl: '@?',
                socialEchoData: '&',
                isNarrowCard: '=',
                showFooter: '=',
                smallTextLimit: '=?'
            }
        };
    }])
    .controller('DocumentCardController', [
        '$scope',
        'MediaTypeService',
        'TagService',
        DocumentCardController
    ]);

    function DocumentCardController($scope, MediaTypeService, TagService) {

        $scope.MediaTypeService = MediaTypeService;
        $scope.TagService = TagService;

        //We only want to display inline images that meet the following minimum requirements
        $scope.minimumImageSize = {
            height: 240,
            width: 240
        };

        if($scope.document && $scope.document.documentId && $scope.TagService.isDocumentBeingTagged($scope.document.documentId)) {
            var tempTag = $scope.TagService.getTagNameInProcess();
            if(Array.isArray($scope.document.tags) && ($scope.document.tags.indexOf(tempTag) < 0)) {
                $scope.document.tags.push(tempTag);
            }
        }

        $scope.documentClick = function documentClick(event, document, url) {
            $scope.parentDocumentClick({ event: event, document: document, url: url});
        };
    }

}



// WEBPACK FOOTER //
// ./source/components/document-card/document-card.js